export const mutations = {
  addHoraire (state, horaire) {
    state.horaire = horaire
  },
  setHoraire (state, horaire) {
    state.horaire = horaire
  },
    addHoraires(state, horaire){
      
    state.horaires = horaire._embedded;
     state.pagination = { ...horaire.page };
    console.log(horaire.page);
  },
}
